import React, { useState, useEffect, useContext } from 'react';
import Footer from '../../component/Footer';
import Navbar from '../../component/Navbar';
import { useNavigate } from 'react-router-dom';
import Arrow from '../Arrow';
import Generalsidebar from '../Generalsidebar';

const UPDATEURL =
  'https://thrive-mqy3.onrender.com/v1/docs/#/Patients/patch_patients__id_';

const userInfo = JSON.parse(localStorage.getItem('userLoggedIn'));

function SettingsProfile() {
  const [showSidebar, setShowSidebar] = useState(false);

  const userInfo = JSON.parse(localStorage.getItem('userLoggedIn'))
    ? JSON.parse(localStorage.getItem('userLoggedIn'))
    : { firstName: '' };

  console.log('userInfo', userInfo);
  function handleArrowClick() {
    setShowSidebar(true);
  }

  const [userName, setUserName] = useState(userInfo.firstName);
  const [userAge, setUserAge] = useState(0);

  const [userState, setUserState] = useState('');
  const [userCity, setUserCity] = useState('');

  const [userBio, setUserBio] = useState('');
  const [aboutUser, setAboutUser] = useState(false);
  const navigate = useNavigate();

  function handleAboutMe() {
    if (!userBio) {
      setAboutUser(true);
      setTimeout(() => {
        setAboutUser(false);
      }, 5000);
      return;
    }
  }

  // const updateUser = async (e) => {
  //   e.preventDefault();
  //   handleAboutMe();

  // try {
  //   const loginDetails = { userName, userAge, userEmail, userBio };
  //   const usersDetail = {
  //     method: "POST",
  //     body: JSON.stringify(loginDetails),
  //     headers: { "Content-Type": "application/json" },
  //   };

  //   const response = await fetch(UPDATEURL, usersDetail);
  //   const data = await response.json();
  //   console.log(data);
  // } catch (error) {
  //   console.log("something went wrong" + error);
  // }
  //   navigate("/profile");
  // };

  const updateProfile = async (e) => {
    e.preventDefault();
    handleAboutMe();

    // try {
    //   const newDetails = {
    //     userName,
    //     userAge,

    //     userCity,
    //     userState,
    //     userBio,
    //   };

    //   const requestData = {
    //     method: "PATCH",
    //     body: JSON.stringify({ ...userInfo, ...newDetails }),
    //     headers: { "Content-Type": "application/json" },
    //   };

    //   const response = await fetch(UPDATEURL, requestData);
    //   const data = await response.json();
    //   console.log(data);
    // } catch (error) {
    //   console.log("something went wrong" + error);
    // }

    navigate('/profile');
  };

  return (
    <div className='bg-[#D9D9D9]'>
      <Navbar />
      <div onClick={handleArrowClick} className='absolute top-24 left-12 z-20'>
        <Arrow />
      </div>
      <div className={showSidebar ? 'show-sidebar' : 'hidden'}>
        <Generalsidebar setShowSidebar={setShowSidebar} />
      </div>
      <form onSubmit={updateProfile}>
        <section className='flex flex-col items-center bg-[#D9D9D9]'>
          {/* --------------Main Area---------------- */}
          <div className='flex flex-col w-[60%] mx-auto items-center gap-4 '>
            {/* -----------Input Section----------- */}

            <div className='flex justify-center pt-12 bg-[#D9D9D9]'>
              <div className='relative mb-4 '>
                <img
                  src='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSrBp4rAadRiXmk6NWl3redkvGJgWGDkBT4vA&usqp=CAU'
                  alt=''
                  className='w-28 h-28 rounded-full object-cover'
                />
                {/* <img
                  src="https://res.cloudinary.com/do3fmrw9n/image/upload/v1700662575/hut5brontqs2u1e2uxk8.png"
                  alt="camera"
                  className="w-12 h-12 absolute left-24 bottom-0"
                /> */}
              </div>
            </div>
            <div className='flex flex-col gap-3 w-full items-center'>
              <h3 className='self-start md:w-[80%] mx-auto'>
                <strong>USERNAME</strong>
              </h3>
              <input
                type='text'
                // value={userName}
                onChange={(e) => setUserName(e.target.value)}
                placeholder={userName ? userName : 'Your Username'}
                className='block w-96 md:w-[80%] rounded-sm shadow-md px-2 py-1'
              />
            </div>
            <div className='flex flex-col gap-3 w-full items-center'>
              <h3 className='self-start md:w-[80%] mx-auto'>
                <strong>AGE</strong>
              </h3>
              <input
                type='text'
                // name="userAge"
                onChange={(e) => setUserAge(e.target.value)}
                placeholder={
                  userInfo.userAge ? userInfo.userAge : 'Enter Your Age'
                }
                className='block w-96 md:w-[80%] rounded-sm shadow-md px-2 py-1'
              />
            </div>
            <div className='flex flex-col gap-3  w-full items-center'>
              <h3 className='self-start md:w-[80%] mx-auto'>
                <strong>EMAIL</strong>
              </h3>
              <input
                type='email'
                placeholder={userInfo.email ? userInfo.email : 'Your Email'}
                // name="email"
                value={userInfo.email}
                className='block w-96 md:w-[80%] rounded-sm shadow-md px-2 py-1'
                disabled
              />
            </div>
            <div className='flex flex-col gap-3 w-full items-center'>
              <h3 className='self-start md:w-[80%] mx-auto'>
                <strong>CITY</strong>
              </h3>
              <input
                type='text'
                // name="userCity"
                placeholder={
                  userInfo.userCity ? userInfo.userCity : 'Enter Your City'
                }
                onChange={(e) => {
                  setUserCity(e.target.value);
                }}
                className='block w-96 md:w-[80%] rounded-sm shadow-md px-2 py-1'
              />
            </div>
            <div className='flex flex-col gap-3 w-full items-center'>
              <h3 className='self-start md:w-[80%] mx-auto'>
                <strong>STATE</strong>
              </h3>
              <input
                type='text'
                required
                placeholder='Your State'
                onChange={(e) => setUserState(e.target.value)}
                className='block w-96 md:w-[80%] rounded-sm shadow-md px-2 py-1'
              />
            </div>
            <div className='flex flex-col gap-3  w-full items-center'>
              <h3 className='self-start md:w-[80%] mx-auto'>ABOUT ME</h3>
              <textarea
                // value={userDetails.aboutMe ? userDetails.aboutMe : ""}
                placeholder={
                  userInfo.aboutMe ? userInfo.aboutMe : 'Write About Yourself'
                }
                // onChange={handleChange}
                onChange={(e) => setUserBio(e.target.value)}
                className=' w-[80%]  rounded-sm shadow-md px-2 py-1 h-32'
                id='enter-about'
                required
              />
              {aboutUser && (
                <p className='text-center mb-4 text-red-500 font-semibold mt-2'>
                  Fill the about me field
                </p>
              )}
            </div>

            <div className='mt-8 '>
              <button
                // onClick={updateProfile}
                className='block w-60 font-semibold text-center text-white bg-[#295700] py-1 rounded-md mb-8'
                id='save-details '>
                SAVE
              </button>
            </div>
          </div>
        </section>
      </form>
      <Footer />
    </div>
  );
}
{
  <Footer />;
}

export default SettingsProfile;
